import React from "react";

import SquaberLink from "../../../common/SquaberLink";

function LoginRegisterPrompt({ registerTo, translate }) {
  return (
    <p className={"text-sm line-height-100 font-medium text-black-5 mb-8"}>
      {translate("auth_login-page_no-account")}{" "}
      <strong className={"font-bold text-black"}>
        <SquaberLink to={registerTo} className={"ml-2"}>
          {translate("auth_login-page_register-link")}
        </SquaberLink>
      </strong>
    </p>
  );
}

export default LoginRegisterPrompt;
